import { useState } from "react";
import {
  UsersPasswordResetPostRequest,
  RequestPasswordReset,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiPasswordReset = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = async (req: RequestPasswordReset) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersPasswordResetPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersPasswordResetPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("パスワードリセットに失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { submit, result, error, isLoading };
};
